export enum MemberRoleType {
  moderator = 'moderator',
  stories = 'stories',
  approved = 'approved',
  administrator = 'administrator',
}
